<div class="dynamic-form">
    <div class="step-wrapper">
        <cm-test-registration-form-content
            *ngIf="isStepSubmitted || formInfo?.fields"
            [modalDetails]="modalDetails"
            [isStepSubmitted]="isStepSubmitted"
            [isResetEnabled]="false"
            [signatureLink]="signature_link"
            (formSubmit)="onFormSubmit($event)"
            [formInfo]="formInfo"
            [step]="step"
        >
        </cm-test-registration-form-content>
    </div>
</div>
